/**
*
*   A ShopifyTools Server Warpper
*       -
*
**/
const ShopifyTools = {

	//Get the ID from the gid, or just return if it's not a
	id: (id) => ( String( id ).indexOf('gid://') > -1 ? id.match(/([^\/]*)\/*$/)[1].split('?')[0] : id ),

	//Rewards
	Rewards: {

		//Load the Customer Rewards
		get: async (data) => await (
			await fetch('/api/shopify-tools/rewards',{
				cache: 'no-store'
			})
		).json(),

		//Points
		points: {

			//Update the Customer Rewards
			add: async (type) => (
				await fetch('/api/shopify-tools/rewards/points',{
					cache: 	'no-store',
					method: 'POST',
					body: 	JSON.stringify({
						type: type
					})
				})
			).json()
		},

		//Birthday
		birthday: {

			//Add the Birthday
			add: async (date) => (
				await fetch('/api/shopify-tools/rewards/birthday',{
					cache: 	'no-store',
					method: 'PUT',
					body: 	JSON.stringify({
						date: date
					})
				})
			).json()
		},

		//Referral Features
		referral: {

			//Add the Referral Date
			add: async (email) => (
				await fetch('/api/shopify-tools/rewards/referral',{
					cache: 	'no-store',
					method: 'PUT',
					body: 	JSON.stringify({
						email: email
					})
				})
			).json(),

			//Validate the Referral
			validate: async (email) => (
				await fetch(`/api/shopify-tools/rewards/referral?email=${ encodeURIComponent( email ) }`,{
					cache: 'no-store'
				})
			).json()

		}
	},

	//Wholesale Options
	Wholesale: {

		//Stores
		stores: {

			//Find Stores by Type
			find: async (type) => await (
				await fetch(`/api/shopify-tools/wholesale/stores?type=${ encodeURIComponent( type ) }`,{
					cache: 'no-store'
				})
			).json(),

			//Get a Retailers Stores
			get: async () => await (
				await fetch('/api/shopify-tools/wholesale/stores',{
					cache: 'no-store'
				})
			).json(),

			//Save the Store Data
			save: async (data) => (
				await fetch('/api/shopify-tools/wholesale/stores',{
					cache: 'no-store',
					method: 'POST',
					body: 	JSON.stringify(data)
				})
			).json()

		},


		//offers
		offer: {

			//Get the Customer's Wholesale Offers
			get: async () => await (
				await fetch('/api/shopify-tools/wholesale/offer',{
					cache: 'no-store'
				})
			).json()

		}

	},



	//Publish / Subscribe
	PubSub: {

		//Subscribe to a Resource
		subscribe: async (id) => await (
			await fetch(`/api/shopify-tools/pubsub?id=${ encodeURIComponent( id ) }`,{
				cache: 'no-store'
			})
		).json(),


		//Publish to a Resource
		publish: async (id , issue , token) => await (
			await fetch('/api/shopify-tools/pubsub',{
				cache: 'no-store',
				method: 'PUT',
				body: 	JSON.stringify({
					id:  	id,
					issue: 	issue,
					token: 	token
				})
			})
		).json(),

		//Was the article helpful or not?
		helpful: {

			//Add a Helpful State
			add: async (id , issue , type) => await (
				await fetch('/api/shopify-tools/pubsub/helpful',{
					cache: 'no-store',
					method: 'PUT',
					body: 	JSON.stringify({
						id: 	id,
						issue: 	issue,
						type: 	type
					})
				})
			).json(),

			//Remove a Helpful State
			remove: async (id , issue , type) => await (
				await fetch('/api/shopify-tools/pubsub/helpful',{
					cache: 'no-store',
					method: 'DELETE',
					body: 	JSON.stringify({
						id: 	id,
						issue: 	issue,
						type: 	type
					})
				})
			).json()

		}

	},


	//Library
	Library: {

		//Get all Library Entries
		batch: async search => await (
			await fetch('/api/shopify-tools/library',{
				cache: 'no-store',
				method: 'POST',
				body: 	JSON.stringify({
					lookup: search
				})
			})
		).json(),

		//Get a Library Entry
		get: async ( classifier , identifier ) => await (
			await fetch(`/api/shopify-tools/library?classifier=${ encodeURIComponent( classifier ) }&identifier=${ encodeURIComponent( identifier ) }`,{
				cache: 'no-store'
			})
		).json()

	},

	//Invoice Functions
	Invoice: {

		//Download an Invoice
		download: (id) => window.location.href = `/api/shopify-tools/invoice/download?id=${ id }`

	},

	//Diffuser App
	Diffuser: {

		//Load the account details
		load: async () => await (
			await fetch(`/api/shopify-tools/diffuser?accessKey=${ new URLSearchParams( window.location.search ).get('accessKey') || '' }`,{
				cache: 'no-store'
			})
		).json(),

		//Returns
		Returns: {

			//Load a Return Object based on its ID
			get: async id => await (
				await fetch(`/api/shopify-tools/diffuser/returns?id=${ id }`,{
					cache: 'no-store'
				})
			).json(),

			//Lookup Rates
			check: async ( id , packages ) => await (
				await fetch('/api/shopify-tools/diffuser/returns',{
					cache: 'no-store',
					method: 'POST',
					body: 	JSON.stringify({
						id: id,
						packages: packages
					})
				})
			).json(),

			//Create a Label for the Return based on the return id and rate id
			create: async ( id , rateId ) => await (
				await fetch('/api/shopify-tools/diffuser/returns',{
					cache: 'no-store',
					method: 'PUT',
					body: 	JSON.stringify({
						id: id,
						rateId: rateId
					})
				})
			).json(),

			//Ship a return with a customer created label
			selfShip: async ( id , carrier , tracking ) => await (
				await fetch('/api/shopify-tools/diffuser/returns',{
					cache: 'no-store',
					method: 'PATCH',
					body: 	JSON.stringify({
						id: id,
						tracking: tracking,
						carrier: carrier
					})
				})
			).json(),

			//Download the Label
			download: async id => await (
				await fetch(`/api/shopify-tools/diffuser/returns/download?id=${ id }`,{
					cache: 'no-store'
				})
			).json()

		},


		Subscription: {

			//Load a Return Object based on its ID
			get: async id => await (
				await fetch(`/api/shopify-tools/diffuser/subscriptions?id=${ id }`,{
					cache: 'no-store'
				})
			).json()

		},


		//Device Functions
		Device: {


			//Replenish Inventory
			replenish: {

				//Mark a replenishment date on a device
				add: async (id , types, date)  => await (
					await fetch('/api/shopify-tools/diffuser/devices',{
						cache: 'no-store',
						method: 'PUT',
						body: 	JSON.stringify({
							accessKey: new URLSearchParams( window.location.search ).get('accessKey'),
							id: id,
							types: types,
							date: date
						})
					})
				).json(),

				//Update a Replenishment
				update: async (id , types, date)  => await (
					await fetch('/api/shopify-tools/diffuser/devices',{
						cache: 'no-store',
						method: 'POST',
						body: 	JSON.stringify({
							accessKey: new URLSearchParams( window.location.search ).get('accessKey'),
							id: id,
							types: types,
							date: date
						})
					})
				).json(),

				//Delete the last replenishment
				delete: async (id , types)  => await (
					await fetch('/api/shopify-tools/diffuser/devices',{
						cache: 'no-store',
						method: 'DELETE',
						body: 	JSON.stringify({
							accessKey: new URLSearchParams( window.location.search ).get('accessKey'),
							id: id,
							types: types
						})
					})
				).json()

			}

		}

	}

};



//Export
export default ShopifyTools;